import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  BarChart,
  Bar,
} from "recharts";
import { formatNumber, formatShortDate } from "./rootDashboardUtils";

export default function RootChartsSection({ sessionsByDay = [], activityByDay = [] }) {
  return (
    <div className="row g-3 mb-4">
      <div className="col-12 col-xl-6">
        <div className="management-card root-section-card h-100">
          <div className="root-card-header">
            <div>
              <h6 className="root-card-title mb-1">Sesiones por dia</h6>
              <small className="text-muted">Ultimos 7 dias</small>
            </div>
            <span className="management-pill root-chip">
              <i className="bi bi-graph-up" />
              {sessionsByDay.length}
            </span>
          </div>
          <div className="root-chart-body">
            {sessionsByDay.length ? (
              <ResponsiveContainer width="100%" height={260}>
                <LineChart data={sessionsByDay} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="date" tickFormatter={formatShortDate} />
                  <YAxis allowDecimals={false} />
                  <Tooltip
                    formatter={(value) => [formatNumber(value), "Sesiones"]}
                    labelFormatter={(label) => formatShortDate(label)}
                  />
                  <Line type="monotone" dataKey="total" stroke="#0ea5e9" strokeWidth={2} dot={{ r: 3 }} />
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div className="root-chart-empty text-muted">Sin sesiones registradas</div>
            )}
          </div>
        </div>
      </div>

      <div className="col-12 col-xl-6">
        <div className="management-card root-section-card h-100">
          <div className="root-card-header">
            <div>
              <h6 className="root-card-title mb-1">Actividad registrada</h6>
              <small className="text-muted">Log de actividad (7 dias)</small>
            </div>
            <span className="management-pill root-chip">
              <i className="bi bi-activity" />
              {activityByDay.length}
            </span>
          </div>
          <div className="root-chart-body">
            {activityByDay.length ? (
              <ResponsiveContainer width="100%" height={260}>
                <BarChart data={activityByDay} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="date" tickFormatter={formatShortDate} />
                  <YAxis allowDecimals={false} />
                  <Tooltip
                    formatter={(value) => [formatNumber(value), "Eventos"]}
                    labelFormatter={(label) => formatShortDate(label)}
                  />
                  <Bar dataKey="total" fill="#10b981" radius={[6, 6, 0, 0]} maxBarSize={36} />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <div className="root-chart-empty text-muted">Sin actividad registrada</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
